import parseISO from 'date-fns/parseISO';
import add from 'date-fns/add';
import type { Duration } from 'date-fns';

import sdk from 'Modules/api/services/sdk';
import { getUserHasSeen } from 'Modules/userLocalStorage/services';

export const USER_BENEFIT_EXPIRATION: Duration = { months: 6 };
export const HAS_SEEN_USER_BENEFITS_KEY = 'user-benefits';

export default async function getShouldAskForBenefits(userId: number) {
  const userHasSeen = getUserHasSeen(userId);
  const [{ body: userBenefits }, hasSeenUserBenefits] = await Promise.all([
    sdk!.client!.helpers.user.users.getUserExpectedBenefits(userId),
    userHasSeen.get(HAS_SEEN_USER_BENEFITS_KEY),
  ]);

  if (hasSeenUserBenefits) {
    return false;
  }

  if (userBenefits.length === 0) {
    return true;
  }

  const [userBenefit] = userBenefits;
  const userBenefitCreatedDate = parseISO(userBenefit.createdAt);
  const userBenefitExpirationDate = add(userBenefitCreatedDate, USER_BENEFIT_EXPIRATION);
  const isUserBenefitExpired = new Date() > userBenefitExpirationDate;

  return isUserBenefitExpired;
}
